import Mock from 'mockjs'

// 生成数据列表

function getDataList(opts) {
    let pageSize = opts.rows
    if (!pageSize) {
        pageSize = 10;
    }
    let maxCount = pageSize
    if (opts.page >= 6) {
        maxCount = 5
    }
    var dataList = []
    for (let i = 0; i < maxCount; i++) {
        let remark = Mock.Random.name()
        dataList.push(Mock.mock({
            'id': '@increment',
            'name': '@name',
            'remark': remark,
            'time|1-100': 100,
            'status': i % 2 === 0 ? 1 : 0,
            'ip': '@ip',
            'createDate': '@datetime'
        }))
    }
    return dataList
}

// 获取日志列表
export function list() {
    return {
        //isOpen: false,
        url: '/demo/list',
        type: 'post',
        data: getResult({}),
        getDataByOpts: getResult
    }
}

export function deleteData() {
    return {
        //isOpen: false,
        url: '/demo/delete',
        type: 'post',
        data: {
            'msg': 'success',
            'code': "1",
        }
    }
}

export function saveData() {
    return {
        //isOpen: false,
        url: '/demo/save',
        type: 'post',
        data: {
            'msg': 'success',
            'code': "1",
        }
    }
}

export function getData() {
    return {
        //isOpen: false,
        url: '/demo/get',
        type: 'get',
        data: {
            'msg': 'success',
            'code': "1",
        }
    }
}

function getResult(opts) {
    if (opts === undefined) {
        opts = {}
    }
    opts.totalItemCount = 55
    let pageSize = opts.rows
    if (!pageSize) {
        pageSize = 10;
    }
    let totalPageCount = 55 / pageSize + 1;
    let dataList = getDataList(opts)
    return {
        'totalItemCount': opts.totalItemCount,
        'pageSize': pageSize,
        'totalPageCount': totalPageCount,
        'pageIndex': 1,
        'rows': dataList
    }
}